import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import styled from 'styled-components';

type PropsType = {
  isOpen: boolean;
  onToggle: () => void;
  title: string;
  children: JSX.Element;
  size?: 'sm' | 'mid' | 'lg' | 'xlg' | '2xlg' | '3xlg';
  isConfirm?: boolean;
  headerChildren?: JSX.Element;
};

// モーダルを表現するためのベースとなるコンポーネント
const BaseModal: React.FunctionComponent<PropsType> = ({
  isOpen,
  onToggle,
  title,
  children,
  size = 'lg',
  isConfirm = false,
  headerChildren,
}) => {
  const maxWidth = () => {
    switch (size) {
      case '3xlg':
        return '90%';
      case '2xlg':
        return '1140px';
      case 'xlg':
        return '950px';
      case 'mid':
        return '600px';
      case 'sm':
        return '30%';
      default:
        return '';
    }
  };

  return (
    <StyledModal
      $maxwidth={maxWidth()}
      centered
      isOpen={isOpen}
      toggle={onToggle}
      size={size}
    >
      <ModalHeader toggle={onToggle}>
        <ModalHeaderInner>
          <Title>{title}</Title>
          {headerChildren}
        </ModalHeaderInner>
      </ModalHeader>
      <StyledModalBody>
        <Content $isConfirm={isConfirm}>{children}</Content>
      </StyledModalBody>
    </StyledModal>
  );
};

type StyledModalProps = {
  $maxwidth: string;
};
const StyledModal = styled(Modal)<StyledModalProps>`
  max-width: ${({ $maxwidth }) => $maxwidth};
`;

const Title = styled.div`
  margin-right: 8px;
`;

const ModalHeaderInner = styled.div`
  display: flex;
  align-items: center;
`;

type ContentProps = {
  $isConfirm: boolean;
};

const Content = styled.div<ContentProps>`
  margin: ${({ $isConfirm }) => (!$isConfirm ? '5px 50px 5px' : '5px 0')};
`;

const StyledModalBody = styled(ModalBody)`
  padding-top: 0;
  padding-bottom: 0;
`;

export default BaseModal;
